<div class="content-dialog user-activity-log-dialog">
  <table class="log-table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Description</th>
        <th>Event</th>
      </tr>
    </thead>
    <tbody *ngIf="!isLoading && logs.length && !error">
      <tr *ngFor="let log of logs">
        <td>{{ log.created_at | date : "short" }}</td>
        <td class="capitalize">{{ log.description }}</td>
        <td class="capitalize">{{ log.event }}</td>
      </tr>
    </tbody>
    <tbody *ngIf="!isLoading && !logs.length && !error">
      <tr>
        <td colspan="3" class="no-data">
          No Activity Logs Found For This User.
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="isLoading" class="dialog-loader">
    <ngx-skeleton-loader count="5" appearance="line"></ngx-skeleton-loader>
  </div>
  <div *ngIf="error" class="dialog-error">{{ error }}</div>

  <app-paginator
    *ngIf="!isLoading && totalItems"
    [rowsPerPage]="10"
    [total]="totalItems"
    [updateParams]="false"
    (paginationUpdated)="fetchLogs($event)"
  ></app-paginator>
</div>
